module.exports = __webpack_public_path__ + "static/media/node.2dcf8a39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/node.svg
// module id = 108
// module chunks = 0